import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { useWebOffer } from 'components/WebOfferPage/web_offer_context';

import './culture-section.scss';

import { VideoAndDescription } from '../../common/VideoAndDescription/VideoAndDescription';
import { VideoEmbed } from '../../common/VimeoEmbed/VideoEmbed';

export function CultureSection(): JSX.Element {
  const { show50HourWorkWeekVideo } = useWebOffer();

  return (
    <div id="culture">
      <Flex className="culture-section" direction="column" gap="lg" padding="xxl">
        <Flex className="culture-section-header" direction="column">
          <Typography variant="title">CULTURE</Typography>
          <Typography variant="header">How we do things and why we do them</Typography>
        </Flex>
        <Typography variant="body">
          The values video is at the center of this page because the entire lifecycle of working at
          Applied Intuition revolves around our values. Read about the Applied Intuition lifecycle{' '}
          <a href="https://hire.applied.co/performance" target="_blank" rel="noopener noreferrer">
            here
          </a>{' '}
          (password: Lifecycle@Applied2025).
        </Typography>
        <VideoEmbed
          src="https://player.vimeo.com/video/813913764?h=27ecd9e895&app_id=122963&dntp"
          title="What we value"
        />
        <div className="additional-context">
          <VideoAndDescription
            src="https://player.vimeo.com/video/815811351?h=8016c778ac&app_id=122963&dntp"
            title="Focus on the Work"
            header="Focus on the work"
            description="We are 100% focused on our work. That means we don’t debate current events at work and leave politics for politicians and policy makers. We realize this approach isn’t for everyone, so you should be comfortable with this policy before joining the team."
            readMoreLink="https://resource.applied.co/focus"
          />
          <VideoAndDescription
            src="https://player.vimeo.com/video/814137876?h=90299e1963&app_id=122963&dntp"
            title="Measuring Leadership"
            header="Measuring leadership"
            description="Leadership performance is key to our success as well as the success of individual contributors. Applied Intuition’s leaders are measured on behaviors that tie to our company’s founding values. Every 6 months, you will fill out a survey that will ask the following questions to score your future manager at Applied Intuition."
            readMoreLink="https://resource.applied.co/scores"
          />
          {show50HourWorkWeekVideo && (
            <VideoAndDescription
              src="https://player.vimeo.com/video/814136902?h=937f79f43b&app_id=122963&dntp"
              title="50-Hour Workweek"
              header="50-hour work week"
              description="We work hard to truly experience the non-linear growth trajectory Applied Intuition can offer. This means we work a productive 50-hour work week. This will be an intense but highly rewarding environment, and you have to be prepared for the challenge."
              readMoreLink="https://hire.applied.co/worklife"
            />
          )}
        </div>
      </Flex>
    </div>
  );
}
